// Components==============
import { useContext } from 'react';
import { TranslateType } from 'typings';
import { GlobalAlertContext } from 'utilities/GlobalContext/GlobalAlert';
// =========================

export function useAlert() {
  const { setAlert, setCustomTitle } = useContext(GlobalAlertContext);

  return (message: TranslateType, customTitle = null) => {
    setAlert(message);
    setCustomTitle(customTitle);
  };
}
